import { LoanApplicationProcessContext, LoanApplicationProcessValue } from '.';
import { useContext } from 'react';

const useLoanApplicationProcess = (): LoanApplicationProcessValue => {
  const context = useContext(LoanApplicationProcessContext);

  if (!context)
    throw new Error(
      'useLoanApplicationProcess must be used under LoanApplicationProcessProvider',
    );

  return context;
};

export default useLoanApplicationProcess;
